import Vue from 'vue';
import Vuex from 'vuex';
import { AppStore } from '@/shared/store/interfaces/AppStore';

Vue.use(Vuex);

export const createStore = (): AppStore => new Vuex.Store({});
